module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "conversation-view"
    }
  }, [_c('router-link', {
    staticClass: "return-to-inbox",
    attrs: {
      "to": "/Inbox"
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-circle-left"
  }), _vm._v(" Back to Inbox\n    ")]), _vm._v(" "), (_vm.notAllowedToViewConversation) ? _c('div', [_c('h1', [_vm._v("You don't have access to this Conversation")])]) : _vm._e(), _vm._v(" "), (!_vm.notAllowedToViewConversation && _vm.conversation) ? _c('div', [_c('h1', [_vm._v(_vm._s(_vm.conversation.subject))]), _vm._v(" "), _c('div', {
    staticClass: "participants"
  }, [_vm._v("\n\n            Participants:\n\n            "), _vm._l((_vm.conversation.participants), function(participant) {
    return _c('span', [_c('router-link', {
      attrs: {
        "to": ("/Developer/" + (participant.stringUrl))
      }
    }, [_vm._v(_vm._s(participant.alias))])], 1)
  }), _vm._v(" "), (!_vm.addParticipantFormVisible && !_vm.confirmAddingParticipant) ? _c('a', {
    staticClass: "add-participant",
    on: {
      "click": function($event) {
        _vm.addParticipantFormVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-circle"
  }), _vm._v(" Add Participant")]) : _vm._e(), _vm._v(" "), (_vm.addParticipantFormVisible) ? _c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addedParticipantName),
      expression: "addedParticipantName"
    }],
    attrs: {
      "id": "newParticipant",
      "type": "text",
      "placeholder": "Search for a Developer"
    },
    domProps: {
      "value": (_vm.addedParticipantName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addedParticipantName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.addParticipantMessage) ? _c('p', {
    staticClass: "add-participant-message"
  }, [_vm._v(_vm._s(_vm.addParticipantMessage))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.matchingDevsResponse), function(dev) {
    return (_vm.devInAliasList(dev)) ? _c('p', {
      staticClass: "new-participant",
      on: {
        "click": function($event) {
          _vm.confirmParticipant(dev)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-plus-circle"
    }), _vm._v(" " + _vm._s(dev.alias))]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.confirmAddingParticipant) ? _c('div', {
    staticClass: "confirm-adding-participant"
  }, [_c('h1', [_vm._v("Confirm to add " + _vm._s(_vm.addedParticipant.alias) + "?")]), _vm._v(" "), _c('form', [_c('input', {
    attrs: {
      "type": "submit",
      "value": "Cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.confirmAddingParticipant = false;
        _vm.addParticipantFormVisible = true
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": ("Yes, add " + (_vm.addedParticipant.alias))
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addParticipant($event)
      }
    }
  })])]) : _vm._e()], 2), _vm._v(" "), (_vm.conversation.messages) ? _c('div', [_c('ul', {
    attrs: {
      "id": "conversation-messages"
    }
  }, _vm._l((_vm.conversation.messages), function(message) {
    return _c('li', [_c('div', {
      staticClass: "avatar-container"
    }, [_c('avatar', {
      attrs: {
        "profile-data": message.from,
        "profile-type": "developer",
        "size": "large",
        "show-xp-info": false
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "message-details"
    }, [_c('span', {
      staticClass: "message-from"
    }, [_c('router-link', {
      attrs: {
        "to": '/Developer/' + message.from.stringUrl
      }
    }, [_vm._v(_vm._s(message.from.alias))])], 1), _vm._v(" "), _c('span', {
      staticClass: "message-date"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(message.timestamp)))]), _vm._v(" "), _c('markdown-content', {
      attrs: {
        "classes": "message-message",
        "content": message.message
      }
    })], 1)])
  })), _vm._v(" "), (!_vm.leaveConversationMode) ? _c('section', {
    attrs: {
      "id": "new-reply"
    }
  }, [_c('h1', [_vm._v("Add Reply")]), _vm._v(" "), _c('form', [_c('markdown-editor', {
    attrs: {
      "placeholder": "Enter a reply"
    },
    model: {
      value: (_vm.newReplyContent),
      callback: function($$v) {
        _vm.newReplyContent = $$v
      },
      expression: "newReplyContent"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.submitReply($event)
      }
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "leave-conversation",
    on: {
      "click": function($event) {
        _vm.leaveConversationMode = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-trash"
  }), _vm._v(" Leave Conversation")])]) : _c('section', {
    attrs: {
      "id": "leave-conversation-form"
    }
  }, [_c('h1', [_vm._v("Are you sure you want to leave this conversation?")]), _vm._v(" "), _c('p', [_vm._v("You will no longer be allowed to view this conversation or participate in it.")]), _vm._v(" "), _c('form', [_c('input', {
    attrs: {
      "type": "submit",
      "value": "Cancel"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.leaveConversationMode = false
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Yes, leave this conversation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.leaveConversation($event)
      }
    }
  })])])]) : _c('div', [_c('loader-large')], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33e7cd7a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Inbox/InboxConversation.vue
// module id = 847
// module chunks = 2